import timeZonesEnam from "@/constant/timeZonesEnam";
import moment from "moment";
import 'moment-timezone';

// Функция преобразования стандартных названий в Etc/GMT-*
export const convertToEtcGMTFormat = (timezone) => {
    const offset = moment().tz(timezone).utcOffset() / 60; // смещение в часах
    const etcFormat = `Etc/GMT-${offset}`;
    // Проверяем, есть ли такой пояс в наших настройках

    const availableTimezones = [
        timeZonesEnam.GMT_MINUS_3,
        timeZonesEnam.GMT_MINUS_4,
        timeZonesEnam.GMT_MINUS_5,
        timeZonesEnam.GMT_MINUS_6,
        timeZonesEnam.GMT_MINUS_7,
        timeZonesEnam.GMT_MINUS_8,
        timeZonesEnam.GMT_MINUS_9,
        timeZonesEnam.GMT_MINUS_10,
        timeZonesEnam.GMT_MINUS_11
    ];
    
    return availableTimezones.includes(etcFormat) ? etcFormat : timeZonesEnam.GMT_MINUS_3;
}